import useGetUrlParams from 'utils/useGetUrlParams';
import { useTranslation } from 'react-i18next';
import { useEffectOnce } from '@mafc/hooks';
const usePaymentErrorHandler = () => {
  const [t] = useTranslation();
  const errorKey = 'error';
  const { searchString, searchParameters } = useGetUrlParams(errorKey);
  let errorMessage = `${t(errorKey)}: ${searchString}`;
  useEffectOnce(() => {
    if (!!searchString) {
      Object.keys(searchParameters).forEach(key => {
        if (key !== errorKey) {
          errorMessage = `${errorMessage}\n${key}: ${searchParameters[key]}`;
        }
      });
      alert(errorMessage);
    }
  });
};

export default usePaymentErrorHandler;
